import { GD } from "../GD";
import { Box, HBox } from "@ui/box/Box";
import Button from "@ui/button/Button";
import Spacer from "@ui/spacer/Spacer";
import { TypoHeadBig, Typo } from "@ui/text/Typo";
import { StartScreenView } from "./StartScreenView";
import { ProjectsView } from "./ProjectsView";

export const SelectProjectView = () => {
	return (
		<StartScreenView>
			<Box
				sx={{
					padding: "60px",
					minWidth: "500px",
					display: "flex",
					flexDirection: "column",
				}}>
				<TypoHeadBig>PROJECTS</TypoHeadBig>
				<Typo>Select project to administrate</Typo>
				<Spacer size="40px" />
				<ProjectsView tiny />
				<Spacer size="40px" />
				<HBox>
					<Spacer grow />
					<Button
						variant="secondary"
						onClick={() => GD.S_AUTH_LOG_OUT.invoke()}>
						Log out
					</Button>
				</HBox>
			</Box>
		</StartScreenView>
	);
};
